export default __webpack_public_path__ + "static/media/Gold.4b451601.png";